import React from 'react';
import { HashLink } from 'react-router-hash-link';
import img from '../images/Web-developer.png';

const Intro = () => {
  return (
    <section
      id="about"
      className="relative overflow-hidden bg-gradient-to-br from-[#eaf2fb] via-[#e1f0fa] to-[#d6e9f8]"
    >
      {/* Decorative Background Shapes */}
      <div className="absolute top-[-5rem] left-[-5rem] w-80 h-80 bg-[#15467a]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-[-5rem] right-[-5rem] w-96 h-96 bg-[#1b5a99]/10 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 lg:py-28">
        <div
          className="flex flex-col-reverse lg:flex-row items-center justify-between gap-12"
          data-aos="fade-up"
        >
          {/* TEXT SIDE */}
          <div
            className="w-full lg:w-1/2 flex flex-col justify-center text-center lg:text-left"
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#15467a] leading-snug">
              Smart, Scalable & Reliable Software Solutions
            </h2>

            <p className="mt-6 text-lg md:text-xl text-gray-600 font-medium">
              At <span className="font-semibold text-[#15467a]">Gravient Technologies</span>, we design and develop high quality web applications, Salesforce solutions, Dealer Management Systems to support supply chain operations, and comprehensive software testing services.
            </p>

            <p className="mt-4 text-lg md:text-xl text-gray-600 font-medium">
              Our team delivers reliable, secure, and scalable solutions that help businesses improve efficiency and stay competitive in today’s fast changing digital landscape.
            </p>

            {/* CTA Buttons */}
            <div className="mt-8 flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center lg:justify-start">
              <HashLink
                smooth
                to="/#services"
                className="text-white bg-[#15467a] hover:bg-[#1b5a99] inline-flex items-center justify-center px-6 py-3 text-lg shadow-lg rounded-xl transition-all duration-300 group"
              >
                Explore Our Services
                <svg
                  className="w-5 h-5 ml-2 transform transition-transform duration-300 group-hover:translate-x-2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </HashLink>

              <HashLink
                smooth
                to="/contact"
                className="text-[#15467a] border border-[#15467a] hover:bg-[#15467a] hover:text-white inline-flex items-center justify-center px-6 py-3 text-lg rounded-xl transition-all duration-300"
              >
                Get In Touch
              </HashLink>
            </div>
          </div>

          {/* IMAGE SIDE */}
          <div className="w-full lg:w-1/2 flex justify-center lg:justify-end relative">
            <div className="relative">
              <img
                alt="Web developer illustration"
                className="max-w-md lg:max-w-lg rounded-xl shadow-2xl relative z-10"
                src={img}
              />
              {/* Glow effect behind image */}
              <div className="absolute inset-0 bg-[#15467a]/10 blur-2xl rounded-full -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
